export enum CorporateUserType {
  CUSTOMER = 'customer',
  VENDOR = 'vendor',
}

export enum CorporateUserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  INVITED = 'invited',
}
